export default defineNuxtPlugin((nuxtApp) => {
  const lenis = shallowRef<InstanceType<typeof import('@studio-freight/lenis').default> | null>(null)
  let animationFrame: number | null = null
  let destroyed = false

  // Smooth scrolling is an enhancement: load and start it once the page is idle, off the critical path.
  nuxtApp.hook('app:mounted', () => {
    onIdle(async () => {
      const { default: Lenis } = await import('@studio-freight/lenis')
      if (destroyed) return
      lenis.value = new Lenis({
        wheelMultiplier: 0.8,
        touchMultiplier: 1,
        lerp: 0.1,
        gestureOrientation: 'vertical',
        smoothWheel: true,
        smoothTouch: true,
      })

      const update = (time: number) => {
        lenis.value?.raf(time)
        animationFrame = requestAnimationFrame(update)
      }
      animationFrame = requestAnimationFrame(update)
    }, 3000)
  })

  nuxtApp.hook('app:beforeUnmount', () => {
    destroyed = true
    if (animationFrame) cancelAnimationFrame(animationFrame)
    lenis.value?.destroy()
    lenis.value = null
  })

  return {
    provide: {
      lenis,
    },
  }
})
